export const TAGE = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
} as const;

export type Tage = typeof TAGE;

export function getTageKeyByValue(
  value: Tage[keyof Tage],
): keyof Tage | undefined {
  return (Object.keys(TAGE) as Array<keyof Tage>).find(
    (key) => TAGE[key] === value,
  );
}
